export default "/images/da378388c9842dd694b1f7608d0bfe90.avif";